import { Component, OnInit } from '@angular/core';
import { UmraSupplierProperties, UmraSupplierService } from '../Services/umra-suppliers.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-umra-supplier-management',
  templateUrl: './umra-supplier-management.component.html',
  styleUrls: ['./umra-supplier-management.component.css']
})
// supplier-management.component.ts
export class UmraSupplierManagementComponent implements OnInit {
  suppliers: UmraSupplierProperties[] = [];
  showForm = false;
  editMode = false;
  supplierForm: FormGroup;
  submitted = false;
  loading = false;
  successMsg: string | null = null;
  error: string | null = null;
  showDeleteModal = false;
  supplierToDelete: UmraSupplierProperties | null = null;

  constructor(private fb: FormBuilder, private service: UmraSupplierService) {
    this.supplierForm = this.fb.group({
      supplierId: [0],
      supplierName: ['', Validators.required],
      supplierLetter: ['', [Validators.required, Validators.maxLength(1)]],
      supplierType: ['External', Validators.required],
      isActive: [true],
      isEnabled: [true],
      markupOnSupplier: [0, Validators.required],
      discountOnSupplier: [0, Validators.required]
    });
  }

  ngOnInit(): void { this.loadSuppliers(); }

  loadSuppliers(): void {
    this.loading = true;
    this.service.getAll().subscribe({
      next: (response) => {
        if (response.success) {
          this.suppliers = response.data;
        } else {
          this.error = response.message || 'Failed to load suppliers';
        }
        this.applyFilters();
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading suppliers:', error);
        this.error = 'Failed to load suppliers. Please try again.';
        this.loading = false;
      }
    });
  }

  searchTerm = '';
  typeFilter = 'all';
  statusFilter = 'all';
  filteredSuppliers: UmraSupplierProperties[] = [];

  get f() { return this.supplierForm.controls; }

  applyFilters(): void {
    let result = [...this.suppliers];
    if (this.typeFilter !== 'all') result = result.filter(s => s.supplierType === this.typeFilter);
    if (this.statusFilter === 'enabled') result = result.filter(s => s.isEnabled);
    if (this.statusFilter === 'disabled') result = result.filter(s => !s.isEnabled);
    const term = this.searchTerm.toLowerCase().trim();
    if (term) result = result.filter(s => s.supplierName.toLowerCase().includes(term) || s.supplierLetter.toLowerCase().includes(term));
    this.filteredSuppliers = result;
  }

  openAdd(): void {
    this.editMode = false;
    this.showForm = true;
    this.supplierForm.reset({ supplierId: 0, supplierType: 'External', isActive: true, isEnabled: true });
  }

  openEdit(s: UmraSupplierProperties): void {
    this.editMode = true;
    this.showForm = true;
    this.supplierForm.patchValue(s);
  }

  cancelForm(): void { this.showForm = false; this.submitted = false; this.supplierForm.reset(); }

  onSubmit(): void {
    this.submitted = true;
    if (this.supplierForm.invalid) return;
    this.service.save(this.supplierForm.value).subscribe(res => {
      if (res.success) {
        this.successMsg = res.message;
        this.cancelForm();
        this.supplierForm.reset();
        this.loadSuppliers();
        setTimeout(() => this.successMsg = null, 3000);
      } else {
        this.error = res.message;
      }
    });
  }

  toggleEnabled(s: UmraSupplierProperties): void {
    this.service.toggleEnabled(s.supplierId, !s.isEnabled).subscribe(res => {
      if (res.success) s.isEnabled = !s.isEnabled;
    });
  }

  confirmDelete(s: UmraSupplierProperties): void { this.supplierToDelete = s; this.showDeleteModal = true; }
  cancelDelete(): void { this.showDeleteModal = false; this.supplierToDelete = null; }
  executeDelete(): void {
    if (this.supplierToDelete)
      this.service.delete(this.supplierToDelete.supplierId).subscribe(() => {
        this.showDeleteModal = false;
        this.loadSuppliers();
        this.successMsg = 'Supplier deactivated';
        setTimeout(() => this.successMsg = null, 2000);
      });
  }
}
